import { createAsyncThunk } from '@reduxjs/toolkit';
import { deleteSalesCopilotThread as deleteSalesCopilotThreadApi } from '../api/hubGptApi';
export const deleteSalesCopilotThread = createAsyncThunk('threads/deleteSalesCopilotThread', threadId => deleteSalesCopilotThreadApi(threadId));